import { CustomerReviewCarouselProps } from "@bluebottlecoffee/design-system/components";
import { CustomerReviewCarousel as Schema } from "../sanity-schema";
import { toImageProps } from "./image";

export function toCustomerReviewCarouselProps(
  data: Schema,
  lang: string,
): CustomerReviewCarouselProps {
  return {
    heading: data.heading[lang],
    ...(data.bgColor && { bgColor: data.bgColor }),
    reviews: data.reviews.map((review) => ({
      productImage: toImageProps(review.productImage, lang),
      productName: review.productName[lang],
      reviewText: review.reviewText[lang],
      reviewerName: review.reviewerName?.[lang] ?? "",
      ...(review.verifiedBuyerLabel && {
        verifiedBuyerLabel: review.verifiedBuyerLabel[lang],
      }),
    })),
  };
}
